export default "__VITE_ASSET__CLp16kRo__"